import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root',
})
export class ToaterMessagesService {
  constructor(private toastr: ToastrService) { }

  toasterTranslateSuccessMessages(
    successMsgDE: string,
    successMsgFR: string,
    currentLang: string
  ) {
    if (currentLang) {
      if (currentLang === 'de') {
        this.toastr.success(successMsgDE);
      } else {
        this.toastr.success(successMsgFR);
      }
    }
    else {
      this.toastr.success(successMsgDE);
    }
  }

  toasterTranslateErrorMessages(
    errorMsgDE: string,
    errorMsgFR: string,
    currentLang: string
  ) {
    if (currentLang) {
      if (currentLang === 'de') {
        this.toastr.error(errorMsgDE);
      } else {
        this.toastr.error(errorMsgFR);
      }
    }
    else {
      this.toastr.error(errorMsgDE);
    }
  }

  toasterTranslateWarnMessages(
    errorMsgDE: string,
    errorMsgFR: string,
    currentLang: string
  ) {
    if (currentLang) {
      if (currentLang === 'de') {
        this.toastr.warning(errorMsgDE);
      } else {
        this.toastr.warning(errorMsgFR);
      }
    }
    else {
      this.toastr.warning(errorMsgDE);
    }
  }

  toasterTranslateMessage(errorMsgDE: string,
    errorMsgFR: string,
    currentLang: string,
    level = ToasterLevel.Success) {
    switch (level) {
      case ToasterLevel.Success:
        this.toasterTranslateSuccessMessages(errorMsgDE, errorMsgFR, currentLang);
        break;
      case ToasterLevel.Warn:
        this.toasterTranslateWarnMessages(errorMsgDE, errorMsgFR, currentLang);
        break;
      case ToasterLevel.Error:
      default:
        this.toasterTranslateErrorMessages(errorMsgDE, errorMsgFR, currentLang);
    }
  }
}

export enum ToasterLevel {
  Success,
  Error,
  Warn
}